import { BasicModel } from './model'
import { Customer, CustomerAddress } from './customer'

export type MeetingLocation = 1 | 2

export const meetingLocations = {
  1: '来店',
  2: '訪問',
}

export type ProjectStatus = 1 | 2 | 3 | 4 | 5

export const projectStatus = {
  1: '契約前',
  2: '着工前',
  3: '工事中',
  4: '完成工',
  5: '失注',
}

export type ReactionType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11

export const reactionTypes = {
  1: 'HP',
  2: 'チラシ',
  3: 'TV',
  4: 'ラジオ',
  5: '看板',
  6: '新聞',
  7: '雑誌',
  8: 'SNS',
  9: '紹介',
  10: '近隣での工事',
  11: 'その他',
}

export type PaymentType = 1 | 2

export const paymentTypes = {
  1: '現金',
  2: 'ローン',
}

export type ProjectFileType = 1 | 2

export const projectFileType = {
  1: '図面',
  2: '写真',
}

export type Project = {
  companyId: string
  customerId: string
  customerAddressId: string
  name: string
  competition: boolean | null
  competitionMemo: string | null
  firstMeetingLocation: MeetingLocation | null
  constructionType: string | null
  status: ProjectStatus | null
  reactionType: ReactionType | null
  lostOrderReason: string | null
  paymentType: PaymentType | null
} & BasicModel

export type ProjectFile = {
  projectId: string
  fileName: string
  fileType: ProjectFileType
  downloadUrl: string | null
} & BasicModel

export type ProjectMember = {
  userId: string
} & BasicModel

export type ProjectOrder = {
  transactionId: string
} & BasicModel

export type ProjectDetail = {
  project: Project
  members: ProjectMember[]
  files: ProjectFile[]
  orders: ProjectOrder[]
  customer: Customer
  address: CustomerAddress
}
